<template lang="pug">
.request-reply-input-modal
  b-modal(v-model="_modalShow" size="lg" title="" no-close-on-backdrop no-close-on-esc @ok="onReply" @cancel="cancel" @shown="scrollToBottom")
    .messages.mb-2(ref="messages" v-if="_showReplyMessages")
      .reply-message.mb-2(v-for="reply in _replyMessages")
        SendRequestReplyMessage(:value="reply")

    .register-body(v-if="request")
      FormTextarea(
        v-model="messageText"
        key-name="返信内容" name="message-text" placeholder="返信内容をご記載ください。"
        :validation-rules="{ required: true, max: 1000 }" :maxlength="1000"
        :styles="{ maxWidth: '600px', width: '600px', minHeight: '160px' }" required)

    template(#modal-footer="{ ok, cancel }")
      ValidationAlert(v-model="showValidationAlert")
      .buttons.m-0
        button.btn.modal-ok-btn(type="button" @click="ok()") 送信
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { BvModalEvent } from "bootstrap-vue";

import { Acceptance, OtherOfficeAcceptanceRequestRepliesGetModel, OtherOfficeAcceptanceRequestReply } from "@/commons/services/OtherOfficeAcceptanceRequestReplies";

import SendRequestReplyMessage from "@/pc/components/otherOfficeRoomSchedules/SendRequestReplyMessage.vue";

import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";

/**
 * ### リクエスト返信入力モーダル
 */
@Component({
  components: {
    SendRequestReplyMessage,
    FormTextarea,
    ValidationAlert
  },
  $_veeValidate: { validator: "new" }
})
export default class RequestReplyInputModal extends Vue {
  /** モーダル表示可否 */
  @Prop()
  value!: boolean;
  /** 表示対象のリクエスト */
  @Prop()
  request!: OtherOfficeAcceptanceRequestRepliesGetModel;

  /** 返信内容 */
  messageText: string = "";

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _showReplyMessages(): boolean {
    return this.request && (this.request.firstReply || (this.request.followUpReplies && 0 < this.request.followUpReplies.length)) ? true : false;
  }

  get _replyMessages(): Array<OtherOfficeAcceptanceRequestReply> {
    if (!this.request || !this.request.firstReply) {
      return [];
    }
    return [this.request.firstReply].concat(this.request.followUpReplies ? this.request.followUpReplies : []);
  }

  get _acceptanceOptions(): Array<{ value: number | string; label: string }> {
    return [
      { value: Acceptance.POSSIBLE, label: "受け入れ可" },
      { value: Acceptance.NEED_CONSULTATION, label: "詳細相談希望" },
      { value: Acceptance.NOT_POSSIBLE, label: "受け入れ不可" }
    ];
  }

  /** ### 送信ボタン押下処理 */
  async onReply(modalEvent: BvModalEvent): Promise<void> {
    modalEvent.preventDefault();

    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      // 送信側の返信なので、acceptanceは常にnullを送信する
      this.$emit("onReply", { acceptance: null, messageText: this.messageText });
    } else {
      this.showValidationAlert = true;
    }

    return;
  }

  /** ### キャンセルボタン押下処理 */
  cancel(): void {
    this.initialize();
    return;
  }

  /**
   * ### メッセージエリアを最下部にスクロールする
   */
  scrollToBottom(): void {
    const element = this.$refs.messages as HTMLElement;
    if (element) {
      element.scrollTop = element.scrollHeight;
    }
    return;
  }

  /** ### 入力値を初期化する */
  public initialize(): void {
    this.messageText = "";
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.messages {
  background-color: $bg-message;
  padding: 1rem;

  max-height: 380px;
  overflow-y: auto;
}

.register-body {
  ::v-deep .register-group {
    margin: 0 !important;
  }
}
</style>
